import React from 'react'

const LogWeighing = ({ stage_, admin, isSuperAdmin = false }) => {
  console.log('stage_', stage_)
  console.log('admin', admin)

  if (!stage_ || !stage_.length) {
    return (
      <div style={{ padding: '10px' }}>
        Лог взвешивания - нет данных для отображения
      </div>
    )
  }

  // Фильтруем и сортируем элементы по времени (новые сверху)
  const filteredItems = stage_
    .filter((item) => Number(item.admin) === Number(admin) || isSuperAdmin)
    .sort((a, b) => b.time - a.time) // Сортировка по убыванию времени

  return (
    <div
      style={{
        maxHeight: '500px',
        overflowY: 'auto',
        padding: '10px',
        border: '1px solid #eee',
        borderRadius: '4px',
      }}
    >
      <div
        style={{
          position: 'sticky',
          top: 0,
          background: 'white',
          padding: '10px 0',
          borderBottom: '1px solid #eee',
          marginBottom: '10px',
        }}
      >
        Лог вашего взвешивания
      </div>

      {filteredItems.length > 0 ? (
        filteredItems.map((item, index) => (
          <div
            key={`${item.id}-${index}`}
            style={{
              marginBottom: '15px',
              border: '1px solid #ddd',
              padding: '10px',
              borderRadius: '4px',
              backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white',
            }}
          >
            <div style={{ margin: '5px 0', fontSize: '11px' }}>
              Команда: <strong>{item.teamName || 'Не указано'}</strong>
            </div>
            <div style={{ margin: '5px 0', fontSize: '11px' }}>
              Время взвешивания:{' '}
              <strong>{new Date(item.time).toLocaleString()}</strong>
            </div>
            <div style={{ margin: '5px 0', fontSize: '11px' }}>
              Количество: <strong>{item.fishCount}</strong>
            </div>
            <div style={{ margin: '5px 0', fontSize: '11px' }}>
              Общий вес: <strong>{item.totalWeight}</strong>
            </div>

            {item.fishList && item.fishList.length > 0 && (
              <div style={{ marginTop: '10px' }}>
                <div
                  style={{
                    margin: '5px 0',
                    fontSize: '11px',
                    fontWeight: 'bold',
                  }}
                >
                  Пойманная рыба:
                </div>
                <ul style={{ margin: '5px 0', paddingLeft: '15px' }}>
                  {item.fishList
                    .sort((a, b) => b.timestamp - a.timestamp) // Сортировка рыбы по времени
                    .map((fish, fishIndex) => (
                      <li
                        key={fishIndex}
                        style={{
                          fontSize: '11px',
                          marginBottom: '3px',
                        }}
                      >
                        Тип: {fish.type}, Вес: <strong>{fish.weight}</strong>,
                        Время: {new Date(fish.timestamp).toLocaleTimeString()}
                      </li>
                    ))}
                </ul>
              </div>
            )}
          </div>
        ))
      ) : (
        <div style={{ padding: '10px', textAlign: 'center' }}>
          Нет данных взвешивания для текущего администратора
        </div>
      )}
    </div>
  )
}

export default LogWeighing
